import { CSSProperties, FC } from 'react';

import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography/Typography';

import { colors } from 'styles/colors';

import { ITextWithImageSection } from 'types/articles';
import { useIsMobile } from 'hooks/useIsMobile';

export const TextWithImageSection: FC<
  ITextWithImageSection & { sectionType?: 'primary' | 'secondary' }
> = ({ image, imageCaption, text, title, sectionType = 'primary' }) => {
  const isMobile = useIsMobile();
  const commonStyles: CSSProperties = {
    fontSize: isMobile ? '16px' : '18px',
    lineHeight: isMobile ? '150%' : '140%',
    color: colors.textPrimary,
  };

  return (
    <Box>
      <Typography
        component={sectionType === 'primary' ? 'h2' : 'h3'}
        fontWeight={700}
        color={colors.textPrimary}
        lineHeight="120%"
        marginBottom="24px"
        sx={{
          fontSize:
            sectionType === 'primary'
              ? {
                  md: '36px',
                  sm: '32px',
                  xxs: '24px',
                }
              : {
                  md: '28px',
                  sm: '24px',
                  xxs: '20px',
                },
        }}
      >
        {title}
      </Typography>

      {image && (
        <Box
          maxWidth="100%"
          maxHeight="100%"
          width="100%"
          sx={{
            margin: {
              sm: '48px 0',
              xxs: '48px 0',
            },
            '& img': {
              width: '100%',
            },
          }}
        >
          <img style={{ display: 'block' }} src={image} alt="header image" />
          {imageCaption && (
            <Typography
              sx={{
                marginTop: '8px',
                fontSize: '14px',
                lineHeight: '150%',
                color: colors.textSecondary,
              }}
            >
              {imageCaption}
            </Typography>
          )}
        </Box>
      )}

      {text &&
        (typeof text === 'string' ? (
          <div
            style={commonStyles}
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          />
        ) : (
          <div style={commonStyles}>{text}</div>
        ))}
    </Box>
  );
};
